module.exports = __webpack_public_path__ + "img/tb1039-4-1974.prt.f17f7568.jpg";